import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'bienvenido',
    component: () => import('../components/Bienvenido.vue')
  },
  {
    path: '/inicioSesion',
    name: 'inicioSesion',
    component: () => import('../components/Acceso/InicioSesion.vue')
  },
  {
    path: '/usuarios',
    name: 'usuarios',
    component: () => import('../components/Acceso/Usuarios.vue')
  },
  {
    path: '/roles',
    name: 'roles',
    component: () => import('../components/Acceso/Roles.vue')
  },
  {
    path: '/productos',
    name: 'productos',
    component: () => import('../components/Catalogos/Productos.vue')
  },
  {
    path: '/facturacion',
    name: 'facturacion',
    component: () => import('../components/Facturacion/Factura.vue')
  },
  {
    path: '/ventas_diarias',
    name: 'ventas diarias',
    component: () => import('../components/Facturacion/VentasDiarias.vue')
  },
  {
    path: '/corte_diario',
    name: 'corte diario',
    component: () => import('../components/Facturacion/CorteDiario.vue')
  },
  {
    path: '/corte_diario_v2',
    name: 'corte diario v2',
    component: () => import('../components/Facturacion/CorteDiariov2.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
